import { useTranslation } from "react-i18next";

/**
 * 9-dot "back to hub" waffle icon. Visually matches the standalone embed
 * (/embed/waffle.js) so users see the same affordance everywhere.
 *
 * `onClick` is optional — when provided, the click is handled in-app (e.g.
 * switching to the launchpad view). Without it the anchor navigates to "/".
 */
export function HubWaffleButton(props: { onClick?: () => void }): JSX.Element {
  const { t } = useTranslation();
  const label = t("waffle.backToHub");
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>): void => {
    if (props.onClick && !event.metaKey && !event.ctrlKey && event.button === 0) {
      event.preventDefault();
      props.onClick();
    }
  };
  return (
    <a href="/" onClick={handleClick} title={label} className="hub-waffle">
      <span className="sr-only">{label}</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="22"
        height="22"
        aria-hidden="true"
        focusable="false"
      >
        <circle cx="5" cy="5" r="1.8" fill="currentColor" />
        <circle cx="12" cy="5" r="1.8" fill="currentColor" />
        <circle cx="19" cy="5" r="1.8" fill="currentColor" />
        <circle cx="5" cy="12" r="1.8" fill="currentColor" />
        <circle cx="12" cy="12" r="1.8" fill="currentColor" />
        <circle cx="19" cy="12" r="1.8" fill="currentColor" />
        <circle cx="5" cy="19" r="1.8" fill="currentColor" />
        <circle cx="12" cy="19" r="1.8" fill="currentColor" />
        <circle cx="19" cy="19" r="1.8" fill="currentColor" />
      </svg>
    </a>
  );
}
